import { createSlice } from "@reduxjs/toolkit"

const getBoolean = (key: string) => sessionStorage.getItem(key) === "true"

const authSlice = createSlice({
  name: "auth",
  initialState: {
    userLoggedIn: getBoolean("isLoggedIn"),
    isMasquerade: getBoolean("masquerade"),
    token_type: sessionStorage.getItem("token_type"),
    api_access_token: sessionStorage.getItem("api_access_token") || null,
    masquerade_access_token: sessionStorage.getItem("masquerade_access_token") || null,
  },
  reducers: {
    setCredentials: (state, action) => {
      state.api_access_token = action.payload["api_access_token"]
      state.token_type = action.payload["token_type"]
      state.userLoggedIn = action.payload["logged_in"]
    },
    logout: (state) => {
      state.userLoggedIn = false
      state.api_access_token = null
      sessionStorage.removeItem("isLoggedIn")
      sessionStorage.removeItem("api_access_token")
      sessionStorage.removeItem("token_type")
    },
    masqueradeLogin: (state, action) => {
      state.masquerade_access_token = action.payload["masquerade_access_token"]
      state.isMasquerade = action.payload["masquerade"]
    },
    masqueradeLogout: (state) => {
      state.isMasquerade = false
      state.masquerade_access_token = null
      sessionStorage.removeItem("masquerade_access_token")
      sessionStorage.removeItem("masquerade")
    },
  },
})

export const { setCredentials, logout, masqueradeLogout, masqueradeLogin } = authSlice.actions
export default authSlice.reducer

export const selectCurrentTokenType = (state: any) => state.auth.token_type
export const selectCurrentAccessToken = (state: any) => state.auth.api_access_token
